import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-child-card',
  templateUrl: 'child-card.component.html',
  styleUrls: ['/abc.scss'],
})
export class ChildCardComponent {
  @Input() cardContent: string = '';
  isSelected: boolean = false;

  toggleSelection() {
    this.isSelected = !this.isSelected;
  }
}



// WEBPACK FOOTER //
// ./src/component/card/child-card.component.ts